<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <div style="padding: 16px 32px 16px 0px">
              <span class="title">数据统计</span>
            </div>
            <div class="aLine"></div>
            <div class="tableInfo">
              <div class="block">
                <el-row :gutter="16">
                  <el-col :span="8">
                    <span class="demonstration">页面/功能：</span>
                    <el-cascader
                      ref="cascader"
                      :options="options"
                      :props="props"
                      clearable
                      @change="changeCascader"
                    ></el-cascader>
                  </el-col>
                  <el-col :span="8">
                    <el-date-picker
                      v-model="date"
                      type="daterange"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="changeDate"
                    ></el-date-picker>
                  </el-col>
                  <el-col :span="6">
                    <el-autocomplete
                      v-model="user_name"
                      :fetch-suggestions="querySearchStu"
                      placeholder="学生搜索"
                      @select="handleSelect"
                    ></el-autocomplete>
                  </el-col>
                  <el-col :span="2">
                    <el-link :underline="false" target="_blank" :href="exportUrl" :disabled="isExport">
                      <el-button type="success" :disabled="isExport">导出</el-button>
                    </el-link>
                  </el-col>
                </el-row>
              </div>
              <div id="charts" class="charts"></div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as Utils from "@/utils/utils.js";
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";

var echarts = require("echarts");

var myChart;
var option;

function getDaysInMonth(month, year) {
  var date = new Date(year, month, 1);
  var days = 0;
  while (date.getMonth() === month) {
    days++;
    date.setDate(date.getDate() + 1);
  }
  return days;
}

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout
  },
  created() {},
  data() {
    return {
      props: { multiple: true },
      options: [],
      meunItem: null,
      meunTitle: "",
      date: "",
      functionType: [],
      stuList: [],
      user_id: "",
      user_name: "",
      timeout: null
    };
  },
  mounted() {
    this.initCharts();
    console.log("getDaysInMonth----------------", getDaysInMonth(1, 2020));
  },
  computed: {
    exportUrl() {
      if (this.date) {
        var year = this.date[0].getFullYear();
        var begin_month = this.date[0].getMonth() + 1;
        var begin_day = this.date[0].getDate();
        var end_month = this.date[1].getMonth() + 1;
        var end_day = this.date[1].getDate();
        var user_id = this.user_id;
        var url = `${URL_PATH}api/adminVisitLog/export?year=${year}&begin_month=${begin_month}&begin_day=${begin_day}&end_month=${end_month}&end_day=${end_day}&token=${localStorage.getItem("token")}`
        if (user_id) {
          url += `&user_id=${user_id}`
        }
        return url;
      } else {
        return ''
      }
    },
    isExport() {
      return !this.date;
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.getfunctionList();
    },
    initCharts() {
      var chartDom = document.getElementById("charts");
      myChart = echarts.init(chartDom);

      option = {
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          data: []
        },
        yAxis: {},
        toolbox: {
          show: false,
          right: 10,
          feature: {
            dataZoom: {
              yAxisIndex: "none"
            },
            restore: {},
            saveAsImage: {}
          }
        },
        dataZoom: [
          {
            type: "inside"
          }
        ],
        series: []
      };
      option && myChart.setOption(option);
    },
    setChart(data) {
      var series = data ? this.getChartSeries(data) : [];
      var xAxis = data ? this.getChartXAxis(data) : [];
      option.xAxis.data = xAxis;
      option.series = series;
      option &&
        myChart.setOption(option, {
          notMerge: true
        });
    },
    resetChart() {
      option.xAxis.data = [];
      option.series = [];
      option &&
        myChart.setOption(option, {
          notMerge: true
        });
    },
    getfunctionList: function() {
      this.$api
        .functionList({
          token: localStorage.getItem("token")
        })
        .then(({ data }) => {
          let fKeys = Object.keys(data.Data);
          let fValues = Object.values(data.Data);
          this.options = fKeys.map((item, index) => {
            return {
              value: item,
              label: item,
              children: fValues[index].map(item => {
                return {
                  value: item,
                  label: item
                };
              })
            };
          });
        });
    },
    changeCascader(e) {
      this.functionType = e.map(item => {
        return item[1];
      });
      if (this.functionType.length && this.date) {
        this.dataByFunction();
      } else if (this.functionType.length === 0) {
        this.resetChart();
      }
    },
    changeDate(e) {
      if (e && e[1].getFullYear() !== e[0].getFullYear()) {
        this.date = [];
        this.$message({
          message: "不支持跨年选择！",
          type: "warning"
        });
        return;
      }
      console.log(e);
      if (this.functionType.length && e) {
        this.dataByFunction();
      } else {
        this.resetChart();
      }
    },
    querySearchStu(queryString, cb) {
      this.user_id = "";
      if (queryString) {
        this.$api
          .getAisInfo({
            token: localStorage.getItem("token"),
            page: 1,
            limit: 999,
            where_name: queryString
          })
          .then(({ data }) => {
            let fKeys = Object.keys(data.Data);
            let fValues = Object.values(data.Data);
            let results = data.Data.model.map(item => {
              return {
                value: item.name_cn,
                user_id: item.id
              };
            });
            cb(results);
            console.log(results);
          });
      } else {
        cb([]);
        if (this.functionType.length && this.date) {
          this.dataByFunction();
        } else {
          this.resetChart();
        }
      }
      console.log(queryString);
      // api_getAisInfo;
    },
    handleSelect(item) {
      console.log(item);
      this.user_id = item.user_id;
      if (this.functionType.length && this.date) {
        this.dataByFunction();
      } else if (this.functionType.length === 0) {
        this.resetChart();
      }
    },
    dataByFunction() {
      this.$api
        .dataByFunction({
          token: localStorage.getItem("token"),
          year: this.date[0].getFullYear(),
          begin_month: this.date[0].getMonth() + 1,
          begin_day: this.date[0].getDate(),
          end_month: this.date[1].getMonth() + 1,
          end_day: this.date[1].getDate(),
          function: this.functionType.join(","),
          user_id: this.user_id
        })
        .then(({ data }) => {
          console.log(data);
          this.formatChartData(data.Data);
        });
    },
    formatChartData(data) {
      var chart = {};
      var year = this.date[0].getFullYear();
      var startM = this.date[0].getMonth() + 1;
      var startD = this.date[0].getDate();
      var endM = this.date[1].getMonth() + 1;
      var endD = this.date[1].getDate();

      while (startM <= endM) {
        var monthDays = getDaysInMonth(startM - 1, year);
        var date = `${year}-${startM}-${startD}`;
        var dateData = [];
        this.functionType.forEach(item => {
          dateData.push(0);
        });
        chart["date" + date] = {
          date: date,
          dateData: dateData
        };
        startD++;
        if (startM === endM) {
          if (startD > endD) {
            startM++;
          }
        } else if (startD > monthDays) {
          startM++;
          startD = 1;
        }
      }

      data.forEach(item => {
        var dataDate = `date${item.year}-${item.month}-${item.day}`;
        var functionIndex = this.functionType.indexOf(item.function);

        if (chart[dataDate]) {
          chart[dataDate].dateData[functionIndex] = +item.visit_count;
        }
      });

      console.log(chart);
      this.setChart(chart);
    },
    getChartXAxis(data) {
      var xAxis = Object.keys(data);
      return xAxis.map(item => {
        return data[item].date;
      });
    },
    getChartSeries(data) {
      var dateData = Object.values(data);
      var series = [];
      this.functionType.forEach((item, index) => {
        series.push({
          name: item,
          type: "line",
          data: dateData.map(function(item) {
            return item.dateData[index];
          }),
          markLine: {
            silent: true
          }
        });
      });
      return series;
    }
  }
};
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
  padding: 32px 0;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}

.charts {
  width: 100%;
  height: calc(100vh - 360px);
  margin: 20px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/statistic.vue